export default __webpack_public_path__ + "static/media/test_img2.68ad6cda.png";